import { ErrorComponent, LoadingComponent, useExecutionDataView } from "@gooddata/sdk-ui";
import React, { useEffect, useState } from "react";
import { newJsonPivot } from "../../utils/jsonPivot";
import { calculatePriceIndexBase100 } from "../../utils/indices";
import { colors } from "../../constants";
import { useAppContext } from "../../contexts/AppContext";
import * as Md from "../../md/full";
import { Dropdown } from "antd";
import { RiUnpinFill } from "react-icons/ri";
import { FiMoreVertical } from "react-icons/fi";
import { useDashboard } from "../../contexts/DashboardProvider";

const IndiceWidget = ({ id, execDefinition, widgetUid, componentChild, ...props }) => {
    const { getColorByCustId, getParamsByCustID } = useAppContext();
    const [data, setData] = useState([]);
    const [categoryColors, setCategoryColors] = useState([]);
    const { unPinwWidget } = useDashboard();
    const { result, status } = useExecutionDataView({
        execution: execDefinition,
        // execution: { seriesBy, slicesBy: [Md.MthCode, displayMode.attribute], filters: [...currentFilterHistory, newPositiveAttributeFilter(Md.FlagPrevMth, ["1"]), newPositiveAttributeFilter(Md.MthCode, monthlist)] },
    });
    const mode = props.mode || "priceIndex";

    const displayMode = {
        key: "Player",
        title: "Player",
        label: "Player",
        formatTitle: (value, ctryId) => getParamsByCustID(value, ctryId)?.custLabel,
        attribute: Md.CustId,
    };

    function formatKpiValue(mode, widgetId, slice) {
        return widgetId === "volume-indices"
            ? mode === "priceIndex"
                ? Number(slice.dataPoints()[27].rawValue) !== 0
                    ? Number(slice.dataPoints()[28].rawValue)
                    : null
                : Number(slice.dataPoints()[28].rawValue)
            : mode === "priceIndex"
            ? 100 * Number(slice.dataPoints()[27].rawValue)
            : slice.dataPoints()[props.selectedKpi.index].rawValue !== null
            ? props.selectedKpi.roundValue(slice.dataPoints()[props.selectedKpi.index].rawValue)
            : null;
    }

    useEffect(() => {
        const slices = result?.data().slices().toArray();
        if (slices?.length > 0) {
            const prePivot = slices?.map((slice) => ({
                mthCode: slice.sliceTitles()[0],
                [displayMode.key]: slice.sliceTitles()[1],
                Value: formatKpiValue(mode, id, slice),
            }));
            const categoryColors = result
                ?.meta()
                .allHeaders()[0][1]
                .reduce((acc, nextHeader, index) => {
                    //@ts-ignore
                    const headerTitle = nextHeader?.attributeHeaderItem?.name;
                    if (!acc.find((item) => item?.name === headerTitle)) {
                        acc.push(
                            Object.assign({
                                name: headerTitle,
                                color: displayMode.key === "Player" ? getColorByCustId(headerTitle) : colors[index],
                            }),
                        );
                    }
                    return acc;
                }, []);
            const data = newJsonPivot(prePivot, { row: displayMode.key, column: "mthCode", value: "Value" });
            setData(data);
            setCategoryColors(categoryColors);
        }
    }, [result]);

    return status === "success" && data.length > 0 ? (
        React.createElement(componentChild, { data, categoryColors, calculation: mode === "rentalEvol" ? calculateRentalEvolDataPoint : calculatePriceIndexBase100, startMonth: props.startMonth, displayBy: displayMode.key, widgetUid, dpTitleHandler: displayMode.formatTitle, ...props })
    ) : status === "loading" ? (
        <div className="min-h-[400px] flex items-center justify-center">
            <LoadingComponent />
        </div>
    ) : (
        <div className="relative">
            <Dropdown
                menu={{
                    items: [
                        {
                            key: "unpin",
                            icon: <RiUnpinFill />,
                            label: "Unpin widget",
                            onClick: () => unPinwWidget(widgetUid),
                        },
                    ],
                }}
                trigger={["click"]}
            >
                <FiMoreVertical className="absolute top-2 right-2 z-40 rounded w-8 h-8 px-1.5 py-1 text-gray-500 cursor-pointer hover:bg-backgroundColor hover:text-indigo-700" />
            </Dropdown>
            <div className="min-h-[400px] flex items-center justify-center">
                <ErrorComponent />
                <span className="text-sm font-medium text-steel/80 text-center py-2">
                    Seems like there is an issue with the data or the widget <br /> try unpinning and re-pinning it
                </span>
            </div>
        </div>
    );
};

const calculateRentalEvolDataPoint = (obj, startMonth) =>
    Object.entries(obj)
        .filter(([key, elem]) => key !== "Player")
        .map(([key, elem]) => elem);

export default IndiceWidget;
